<template>
  <div class="v-call-container">
    <loader v-if="loading" />

    <aside class="v-status-panel">
      <ul class="v-status-list">
        <li class="v-status-item online">
          <span class="v-status-text">{{ titleStatus }}</span>
        </li>
        <li v-if="!isClient" class="v-status-item offline">
          <span class="v-status-text">{{ titleStatusClient }}</span>
        </li>
        <li class="v-status-item info">
          <span class="v-status-dot" :class="{ active: isInCall }"></span>
          {{ isInCall ? 'Вы на связи...' : 'Ожидание вызова' }}
        </li>
      </ul>
    </aside>

    <div class="v-main-content">
      <div v-if="isAgent" class="v-controls">
        <div class="v-buttons">
          <button
            @click="controllerEventCall"
            :class="{ active: isInCall }"
            class="v-call-button"
          >
            {{ !isInCall ? '☎️ Позвонить' : '🛑 Завершить звонок и сохранить видео' }}
          </button>
        </div>
      </div>

      <div class="v-media-video">
        <div class="v-local-video">
          <h2>Вы</h2>
          <video ref="localVideo" muted autoplay></video>
        </div>

        <div class="v-remote-video">
          <h2>Абонент</h2>
          <video ref="remoteVideo" autoplay></video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { configIceServer, possibleMimeTypes } from '@/gavnoCode/configWebRtc';

export default {
  data() {
    return {
      loading: null,
      initTimeRecord: null,
      closeTimeRecord: null,
      urlParams: new URLSearchParams(window.location.search),
      optionsRecording: {
        mimeType: null,
        audioBitsPerSecond: 128000,
        videoBitsPerSecond: 2500000,
      },
      mediaConstraints: {
        video: {
          width: { min: 160, ideal: 320 },
          height: { min: 120, ideal: 240 },
          frameRate: { min: 10, ideal: 15, max: 20 },
        },
        audio: true,
      },
      recordedChunks: [],
      remoteChunks: [],
      remoteMediaRecorder: null,
      mediaRecorder: null,
      pendingCandidates: [],
      isAgent: false,
      isInCall: false,
      localStream: null,
      remoteStream: new MediaStream(),
      signaler: null,
      peerConnection: null,
      titleStatus: 'Ожидание...⏳',
      titleStatusClient: 'Абонент не в сети 📵',
    };
  },
  components: {
    loader: () => import('@/views/pdlloan/uiLoader'),
  },
  mounted() {

    this.$palantir.trackAction(205,JSON.stringify(this.urlParams.get('role')));

    this.signaler = new WebSocket(this.installWsConnect());
    this.peerConnection = new RTCPeerConnection(configIceServer);

    this.isAgent = this.urlParams.get('role') === 'agent';

    this.peerConnection.onicecandidate = ({ candidate }) => {
      this.$palantir.trackAction(206,JSON.stringify(candidate));
      if (candidate) {
        this.signaler.send(JSON.stringify({
          type: 'candidate',
          candidate: candidate,
        }));
      }
    };

    navigator.mediaDevices.getUserMedia(this.mediaConstraints)
      .then(stream => {
        this.$palantir.trackAction(208,JSON.stringify(stream));
        this.localStream = stream;

        stream.getTracks().forEach(track => {
          this.peerConnection.addTrack(track, stream);
        });

        this.$refs.localVideo.srcObject = stream;

        if (this.isClient) {
          this.titleStatus = 'Ожидание подключения...⏳';
        } else {
          this.titleStatus = 'Вы в сети ✅';
        }

        const mimeType = this.getSupportedMimeType();
        this.optionsRecording.mimeType = mimeType;
      })
      .catch(error => {
        this.$palantir.trackAction(207,JSON.stringify(error));
        console.error('Ошибка доступа к камере:', error);
        alert('Не удалось получить доступ к медиа');
      });

    this.peerConnection.ontrack = event => {
      this.$palantir.trackAction(209,JSON.stringify(event));
      console.log('Получен новый трек:', event.track.kind);

      if (!this.remoteStream.getTracks().some(t => t.id === event.track.id)) {
        this.remoteStream.addTrack(event.track);
      }

      this.$refs.remoteVideo.srcObject = this.remoteStream;
      // this.startRemoteRecording(this.remoteStream);

      // if (!this.remoteMediaRecorder && this.remoteStream.getVideoTracks().length > 0) {
      //   this.startRemoteRecording(this.remoteStream);
      // }
    };

    this.peerConnection.onconnectionstatechange = () => {
      this.titleStatus =
        this.peerConnection.connectionState === 'connected'
          ? 'Соединение установлено ✅'
          : 'Ожидание...⏳';

      this.$palantir.trackAction(210,JSON.stringify(this.titleStatus));
    };

    this.connectToSignalingServer();
  },
  methods: {
    installWsConnect() {
      const isDev = window.location.hostname === 'dev.msk.finmoll.com';
      return isDev
        ? 'wss://webrtc.t1.msk.finmoll.com:443'
        : 'wss://webrtc.p2.msk.finmoll.com:443';
    },
    dateFormat(dt) {
      let day = dt.getDate();
      let month = (dt.getMonth() + 1) < 10 ? '0' + (dt.getMonth() + 1) : (dt.getMonth() + 1);
      day = day < 10 ? '0' + day : day;
      let h = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours();
      let m = dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes();
      let s = dt.getSeconds()< 10 ? '0' + dt.getSeconds() : dt.getSeconds();
      return dt.getFullYear() + '-' + month + '-' + day + ' ' + h + ':' + m + ':' + s;
    },
    getSupportedMimeType() {
      return possibleMimeTypes.find(mimeType => MediaRecorder.isTypeSupported(mimeType)) || 'video/webm';
    },

    startRemoteRecording(stream) {
      this.remoteMediaRecorder = new MediaRecorder(stream, this.optionsRecording);

      this.remoteMediaRecorder.ondataavailable = event => {
        this.remoteChunks.push(event.data);
      };
      this.remoteMediaRecorder.start(1000);
      this.initTimeRecord = new Date();
    },

    startLocalRecording(stream) {
      this.mediaRecorder = new MediaRecorder(stream, this.optionsRecording);

      this.mediaRecorder.ondataavailable = event => {
        this.recordedChunks.push(event.data);
      };
      this.mediaRecorder.start(1000);
      this.initTimeRecord = new Date();
    },

    stopRecording() {
      if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
        this.mediaRecorder.stop();
        this.closeTimeRecord = new Date();
      }

      if (this.remoteMediaRecorder && this.remoteMediaRecorder.state !== 'inactive') {
        this.remoteMediaRecorder.stop();
        this.closeTimeRecord = new Date();
      }

      if (this.recordedChunks.length > 0) {
        const blob = new Blob(this.recordedChunks, {
          type: this.optionsRecording.mimeType
        });
        this.sendVideoBlob(blob, 'agent');
      }

      if (this.remoteChunks.length > 0) {
        const blob = new Blob(this.remoteChunks, {
          type: this.optionsRecording.mimeType
        });
        this.sendVideoBlob(blob, 'client');
      }
      // `${ this.urlParams.get('demandId') }_ДИАЛОГ_КАНДИДАТ.${ this.optionsRecording.mimeType.includes('webm') ? 'webm' : 'mp4' }`
    },

    connectToSignalingServer() {
      this.signaler.onopen = () => {
      const demandId = this.urlParams.get('demandId');
      const staffId = this.urlParams.get('staffId');
      const guid = this.urlParams.get('r');
      const role = this.isAgent ? 'agent' : 'client';

      const dataMessagesAgent = {
        type: 'Mount',
        role: role,
        demandId,
        staffId,
        guid,
      };

      const dataMessagesClient = {
        type: 'Mount',
        guid,
        role: role,
      };

        this.signaler.send(JSON.stringify(
          role === 'agent' ? dataMessagesAgent : dataMessagesClient,
        ));

        this.$palantir.trackAction(211,JSON.stringify(role === 'agent' ? dataMessagesAgent : dataMessagesClient));
      }

      this.signaler.onmessage = async event => {
        let data = event.data;
        if (data instanceof Blob) {
          data = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(reader.error);
            reader.readAsText(data);
          });
        }

        try {
          let message = JSON.parse(data);

          if (message.type === 'Connected' && message.role === 'client') {
            this.titleStatusClient = 'Клиент в сети ✅';
          }

          if (message.type === 'Connected' && message.role === 'agent') {
            this.titleStatusClient = 'Агент в сети ✅';
          }

          if (message.type === 'offer') {
            if (!this.isAgent) {
              if (!this.localStream) {
                this.localStream = await navigator.mediaDevices.getUserMedia(this.mediaConstraints);
                this.$refs.localVideo.srcObject = this.localStream;

                this.localStream.getTracks().forEach(track => {
                  this.peerConnection.addTrack(track, this.localStream);
                });
              }

              await this.peerConnection.setRemoteDescription(new RTCSessionDescription(message));
              const answer = await this.peerConnection.createAnswer();
              this.$palantir.trackAction(213,JSON.stringify({ type: 'answer', sdp: answer.sdp }));
              await this.peerConnection.setLocalDescription(answer);
              this.signaler.send(JSON.stringify({ type: 'answer', sdp: answer.sdp }));
            }
          }

          if (message.type === 'answer') {
            await this.peerConnection.setRemoteDescription(new RTCSessionDescription(message));
            this.isInCall = true;
            this.startRemoteRecording(this.remoteStream);
          }

          if (message.type === 'candidate') {
            const iceCandidate = new RTCIceCandidate({
              candidate: message.candidate.candidate,
              sdpMid: message.candidate.sdpMid,
              sdpMLineIndex: parseInt(message.candidate.sdpMLineIndex, 10),
              usernameFragment: message.candidate.usernameFragment
            });

            if (this.peerConnection.remoteDescription) {
              await this.peerConnection.addIceCandidate(iceCandidate);
            } else {
              this.pendingCandidates.push(iceCandidate);
            }
            this.$palantir.trackAction(215,JSON.stringify(iceCandidate));
          }

          if (message.type === 'ping') {
            this.heartbeat.call(this.signaler);
            this.$palantir.trackAction(216,'');
          }
        } catch (error) {
          this.$palantir.trackAction(212,JSON.stringify(error));
          console.error('Ошибка при парсинге JSON:', error);
        }
      };

      this.signaler.onerror = err => {
        console.error('Ошибка сигнального сервера:', err);
        this.$palantir.trackAction(217,JSON.stringify(err));
      };
    },

    async controllerEventCall() {
      if (!this.isInCall) {
        const tryStartCall = async () => {
          if (this.isInCall && this.titleStatusClient === 'Клиент в сети ✅') {
            return await this.initCall();
          }
          try {
            await this.initCall();
          } catch (error) {
            console.error('Ошибка при initCall:', error);
          }
          setTimeout(tryStartCall, 1000);
        };
        await tryStartCall();
      } else {
        this.endCall();
      }
    },

    async initCall() {
      if (!this.localStream) {
        alert('Не удалось получить доступ к камере');
        return;
      }

      this.titleStatus = 'Инициируем звонок...📞';

      try {
        const offer = await this.peerConnection.createOffer();
        await this.peerConnection.setLocalDescription(offer);
        this.$palantir.trackAction(218,JSON.stringify(offer));
        this.signaler.send(JSON.stringify({ type: 'offer', sdp: offer.sdp }));
        this.isInCall = true;

        this.startLocalRecording(this.localStream);
      } catch (error) {
        console.error('Ошибка при создании offer:', error);
      }
    },

    endCall() {
      this.$palantir.trackAction(219,'');
      this.peerConnection.close();
      this.signaler.close();
      this.$refs.localVideo.srcObject = null;
      this.$refs.remoteVideo.srcObject = null;
      this.titleStatus = 'Звонок завершён';
      this.titleStatusClient = '';
      this.isInCall = false;
      this.stopRecording();
    },
    // sendVideoBlob(blob, role) {
    //   this.$palantir.trackAction(220,'');
    //   const formData = new FormData();

    //   formData.append('Content', blob);
    //   formData.append('staffId', this.urlParams.get('staffId').toString());
    //   formData.append('role', role);
    //   formData.append('demandId', this.urlParams.get('demandId').toString());
    //   formData.append('dateCreate', this.dateFormat(new Date()));
    //   formData.append('start', this.dateFormat(this.initTimeRecord));
    //   formData.append('finish', this.dateFormat(this.closeTimeRecord));
    //   formData.append('dateCall', this.dateFormat(this.initTimeRecord));
    //   formData.append('token', this.urlParams.get('r'));

    //   this.loading = true;
    //   axios.post('https://x.t1.msk.finmoll.com/video-call/api/videocall', formData)
    //   .then(data => {
    //     this.$palantir.trackAction(221,JSON.stringify(data));
    //   })
    //   .catch(error => {
    //     this.$palantir.trackAction(222,JSON.stringify(error));
    //   })
    //   .finally(() => this.loading = false);
    // },
        sendVideoBlob(blob, role) {
      this.$palantir.trackAction(220,'');
      const formData = new FormData();

      formData.append('Content', blob);
      formData.append('staffId', this.urlParams.get('staffId').toString());
      formData.append('role', role);
      formData.append('demandId', this.urlParams.get('demandId').toString());
      formData.append('dateCreate', this.dateFormat(new Date()));
      formData.append('start', this.dateFormat(this.initTimeRecord));
      formData.append('finish', this.dateFormat(this.closeTimeRecord));
      formData.append('dateCall', this.dateFormat(this.initTimeRecord));
      formData.append('token', this.urlParams.get('r'));

      this.loading = true;
      axios.post('https://x.msk.finmoll.com/video-call/api/videocall', formData)
      .then(data => {
        this.$palantir.trackAction(221,JSON.stringify(data));
        this.titleStatus = 'Звонок завершён, видео сохранено';
      })
      .catch(error => {
        if (error.response) {
          alert('Error', JSON.stringify(error.response.data) + ' ' + JSON.stringify(error.response.status) + ' '  + JSON.stringify(error.response.headers) + ' ' + JSON.stringify(error));
        } else if (error.request) {
          alert('Error', JSON.stringify(error.request) + ' ' + JSON.stringify(error));
        } else {
          alert('Error', JSON.stringify(error.message) + ' ' + JSON.stringify(error));
        }
        this.$palantir.trackAction(222,JSON.stringify(error));
      })
      .finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.v-call-container {
  display: flex;
  gap: 20px;
  background: white;
  padding: 20px;
  border-radius: 10px;
}
.v-status-panel {
  flex: 0 0 220px;
  background: #ffffff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #eaeaea;
}
.v-status-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.v-status-item {
  padding: 10px 0;
  font-size: 0.95rem;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px dashed #eee;
}
.v-status-item:last-child {
  border-bottom: none;
}
.v-status-item.online .status-text {
  font-weight: 600;
  color: #2e8b57;
}
.v-status-item.offline .status-text {
  color: #999;
}
.v-status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #ccc;
  border-radius: 50%;
  transition: background 0.3s;
}
.v-status-dot.active {
  background: #4caf50;
}
.v-main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.v-controls {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
.v-buttons {
  display: flex;
  gap: 15px;
}
.v-call-button {
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: 600;
  color: white;
  background-color: #43ac35;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(233, 30, 99, 0.2);
  transition: all 0.2s ease;
  min-width: 160px;
}
.v-call-button:hover {
  opacity: .8;
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(233, 30, 99, 0.3);
}

.v-call-button:active {
  transform: translateY(0);
}

.v-call-button.active {
  background: #d32f2f;
  box-shadow: 0 4px 12px rgba(211, 47, 47, 0.3);
}
.v-call-button.active:hover {
  background: #b71c1c;
}
.v-media-video {
  display: flex;
  gap: 15px;
  width: 100%;
  max-width: 780px;
}
.v-local-video,
.v-remote-video {
  flex: 1;
  text-align: center;
}
.v-local-video h2,
.v-remote-video h2 {
  margin: 0 0 8px 0;
  font-size: 1rem;
  color: #555;
  font-weight: 500;
}
video {
  width: 100%;
  max-width: 372px;
  min-width: 320px;
  height: auto;
  border-radius: 12px;
  background: #333;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

@media (max-width: 768px) {
  .v-call-container {
    flex-direction: column;
    padding: 10px;
  }

  .v-status-panel {
    flex: auto;
    max-width: 100%;
    margin-bottom: 15px;
  }

  .v-media-video {
    flex-direction: column;
    align-items: center;
  }

  .v-local-video,
  .v-remote-video {
    width: 100%;
    max-width: 372px;
  }
}
</style>
